import { IEventMarketBtsFromWS } from '@/types/event';
import { AbstractMarket } from '@/models/abstractMarket';
import { BetSelection } from '@/constants';

export class MarketBtsItem extends AbstractMarket {
    public yesPrice: string | null;
    public noPrice: string | null;
    public yesBookmakerId: number | null;
    public noBookmakerId: number | null;
    public yesPriceList: [number, number][] | null;
    public noPriceList: [number, number][] | null;
    public feedCount: number;
    public marginPerc: string | null;

    constructor(data: IEventMarketBtsFromWS) {
        super();

        this.setPreviousPrice(BetSelection.BtsYes, data.price_yes_max);
        this.setPreviousPrice(BetSelection.BtsNo, data.price_no_max);

        this.yesPrice = data.price_yes_max;
        this.noPrice = data.price_no_max;
        this.yesBookmakerId = data.price_yes_max_site_id;
        this.noBookmakerId = data.price_no_max_site_id;
        this.yesPriceList = data.price_yes_list ? JSON.parse(data.price_yes_list) : null;
        this.noPriceList = data.price_no_list ? JSON.parse(data.price_no_list) : null;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }

    public update(data: IEventMarketBtsFromWS) {
        this.setPreviousPrice(BetSelection.BtsYes, this.yesPrice);
        this.setPreviousPrice(BetSelection.BtsNo, this.noPrice);

        this.yesPrice = data.price_yes_max;
        this.noPrice = data.price_no_max;
        this.yesBookmakerId = data.price_yes_max_site_id;
        this.noBookmakerId = data.price_no_max_site_id;
        this.yesPriceList = data.price_yes_list ? JSON.parse(data.price_yes_list) : null;
        this.noPriceList = data.price_no_list ? JSON.parse(data.price_no_list) : null;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }
}
